
export { useAuthentication } from "/home/runner/work/apollo/apollo/packages/features/authentication/src/presentation/hooks/use-authentication/use-authentication.ts"